import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import { confirmarEmail } from "../services/api";

export default function ConfirmarEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [estado, setEstado] = useState("processando"); // processando | ok | erro
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setEstado("erro"); setMsg("Link inválido — falta o token."); return; }
    confirmarEmail(token)
      .then(() => { setEstado("ok"); })
      .catch((e) => { setEstado("erro"); setMsg(e.message || "Não foi possível confirmar."); });
  }, [token]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-md mx-auto px-4 py-12">
        <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm text-center">
          {estado === "processando" && <p className="text-gray-500">Confirmando seu e-mail...</p>}
          {estado === "ok" && (
            <>
              <div className="text-4xl">✓</div>
              <h1 className="mt-2 text-xl font-bold text-green-700">E-mail confirmado!</h1>
              <p className="mt-1 text-sm text-gray-600">Sua conta agora tem o selo de verificação. Obrigado!</p>
              <Link to="/" className="inline-block mt-4 text-sm text-primary font-semibold hover:underline">Ir para a página inicial →</Link>
            </>
          )}
          {estado === "erro" && (
            <>
              <div className="text-4xl">⚠️</div>
              <h1 className="mt-2 text-xl font-bold text-red-700">Não foi possível confirmar</h1>
              <p className="mt-1 text-sm text-gray-600">{msg}</p>
              <p className="mt-1 text-xs text-gray-400">O link pode já ter sido usado. Sua conta continua funcionando normalmente.</p>
              <Link to="/" className="inline-block mt-4 text-sm text-primary font-semibold hover:underline">Voltar ao início</Link>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
